export default "__VITE_ASSET__DXXi6v0M__"